module.exports = __webpack_public_path__ + "img/Group 64.43836d1b.svg";